import { useNavigate } from 'react-router-dom'
import { Screen, ScreenTitle, PrimaryButton } from '../ui/Screen.jsx'
import { NavBack } from '../ui/NavBar.jsx'
import { useConfigBundle, screensOf } from '../config.js'

/**
 * Where "Stop for now" lands. Deliberately the least eventful screen in the app.
 *
 * TWO JOBS, FROM TWO DOCUMENTS, AND THEY AGREE.
 *
 * DS-5 §7.4 wants the exit to leave the app in a NEUTRAL state: someone whose
 * phone is monitored needs to be able to stop without the act looking like
 * anything, and without her disclosure staying on screen for whoever picks the
 * phone up next. So nothing here names an instrument, quotes an item, shows a
 * count, or indicates what kind of study this is.
 *
 * DS-3 B2 / DS-6 appendix B wants three facts and no fourth: her answers are
 * saved, she can come back, and the check-ins begin once this part is finished.
 * config owns those sentences.
 *
 * FORBIDDEN HERE, and the third one is the subtle one:
 *  - How far through she is — as a fraction, a percentage, or a count of what
 *    is left. That is the progress indicator following her out of the door.
 *  - Anything framing stopping as loss, waste, or a decision to reconsider.
 *  - Any encouragement to return, any "we'll miss you", any urgency.
 *
 * Fact 3 is present SO SHE CAN CHOOSE, not to make her continue. If it reads as
 * leverage it is wrong — which is why it is stated flatly, last, and not
 * attached to the control.
 *
 * The way back is a SECONDARY control and carries no adjective. A primary
 * button here would be the app leaning on her to resume, which is precisely the
 * encouragement appendix B forbids.
 */
export default function Paused() {
  const navigate = useNavigate()
  const { data: bundle } = useConfigBundle()
  const copy = screensOf(bundle)

  return (
    <Screen disposition="status" support nav={{ left: <NavBack /> }} action={<PrimaryButton onClick={() => navigate('/', { replace: true })}>Carry on</PrimaryButton>}>
      <ScreenTitle>Paused</ScreenTitle>

      <p className="text-base leading-relaxed text-[var(--ink-700)]">
        {copy?.stop_for_now?.body ??
          'Everything you have answered is saved. You can come back and carry on from where you stopped. The check-ins begin once this part is finished.'}
      </p>

    </Screen>
  )
}
